<template>
  <div class="">
    <div class="top-search-box">
      <topTab :rout="rout"></topTab>
    </div>
    <div class="content">
    <img class="page-logo" src="@/assets/home/3.png" alt="" />

    <div class="title">
      <div class="title-line"></div>
      <span>生肖算命</span>
    </div>
    <div class="text">
      <p>
        传统算命生肖运程运势预测,超准,为您提供生肖运势、运程、流年大运、事业家庭和人缘财气的吉凶福祸、旺衰宜忌事件、姻缘深浅等等信息参考。
      </p>
    </div>

    <div class="select-time">
      <span>阳历（公历）生日</span>
      <div class="select-box" @click="showdate = true">
        <span>{{ date }}</span>
        <i class="iconfont icon-triangle-left"></i>
      </div>
    </div>
    <div style="height: 3rem"></div>
    <div class="start-btn" @click="start">开始测算</div>

    <select-date
      v-model="showdate"
      :lunar="lunar"
      @confirm="dateConfirm"
      :date="date"
    />
    <shareBottomComp v-if="share == 1"></shareBottomComp>
</div>
  </div>
</template>

<script>
/**
@description:生肖算命
@createTime:2021-08-26
@create:wq
*/
import topTab from "@/components/topTab";

import selectDate from "@/components/selectDate.vue";
import shareBottomComp from '@/components/shareBottomComp'
import { shareJsSdk,HERF, getQueryString } from "@/utils/tool";
export default {
  name: "",
  props: {},
  components: { selectDate ,shareBottomComp,topTab},
  data() {
    return {
      showdate: false,
      lunar: 0,
      date: "请选择出生年月日",
      share:0,
      rout:[{
        name:'首页',
        path:'/home'
      },{
        name:'生肖算命',
        path:'/sxsm'
      },]
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    if (getQueryString("share")) {
      this.share = 1;
    }else{
      this.share = 0
    }
    shareJsSdk('sxsm','生肖算命','','',HERF+'/image/3.png')
  },
  methods: {
    start() {
      if (this.date === '请选择出生年月日') return this.Toast("请选择日期");
      this.chineseZodiac();
    },
    dateConfirm(data) {
      this.lunar = data.lunar;
      this.date = data.date;
    },
    chineseZodiac() {
      const date = this.date.split("-")
      this.api.chineseZodiac({year:date[0],month:date[1],day:date[2]}).then((res) => {
        localStorage.setItem('result',JSON.stringify(res.data))
        this.$router.push('sxsmres')
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  overflow: hidden;
  margin: 0 0.24rem;
}
.page-logo {
  width: 1.2rem;
  /* height: 1.2rem; */
  display: block;
  margin: 0.76rem auto;
}
.title {
  display: flex;
  align-items: center;

  font-size: 0.3rem;
  font-weight: 400;
  color: #f9647d;
  .title-line {
    width: 0.08rem;
    height: 0.34rem;
    background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
    border-radius: 0px 0.04rem 0.04rem 0px;
    margin-right: 0.1rem;
  }
}
.text {
  margin-top: 0.24rem;
  font-size: 0.24rem;
  font-weight: 400;
  color: #666666;
  p {
    text-indent: 2em;
  }
}
.sex {
  //   padding: 0 0.34rem;
  margin: 1rem 0 0.46rem;
  height: 0.8rem;
  border-radius: 0.4rem;
  box-sizing: border-box;
  background: #f0f0f0;
  overflow: hidden;

  font-size: 0.3rem;
  font-weight: 400;
  color: #666666;
  display: flex;
  > div {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .action {
    color: #ffffff;
    background: #4fd9d5;
  }
}
.select-time {
  margin: 0.26rem 0;
  display: flex;
  align-items: center;
  > span {
    font-size: 0.3rem;
    font-weight: 400;
    color: #666666;
    margin-right: 0.38rem;
  }
  .select-box {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.24rem 0 0.44rem;
    border-radius: 0.5rem;
    background: #f0f0f0;
    border: 1px solid #e6e6e6;
    height: 0.76rem;
    span {
      font-size: 0.24rem;
      font-weight: 500;
      color: #cccccc;
    }
    i {
      font-size: 0.28rem;
      color: #53cedc;
    }
  }
}
.tips {
  margin-top: 0.7rem;
  display: flex;
  font-size: 0.24rem;
  font-weight: 400;
  color: #999999;
}

.start-btn {
  width: 7rem;
  height: 0.88rem;
  background: #4fd9d5;
  border-radius: 0.54rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 1.2rem;
  left: 50%;
  transform: translateX(-50%);

  font-size: 0.3rem;
  font-weight: 400;
  color: #ffffff;
}
</style>